import styled, { css, keyframes } from 'styled-components';
import media from '../../../styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';

let isMobile = isMobileDevice();

export const HeaderDiv = styled.header`
    width: 100%;
    height: 3.75rem;
    display: flex;
    align-items: center;
    position: ${(props) => (props.isBanner ? 'relative' : 'fixed')};
    top: 0;
    left: 0;
    background: #140f4b 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 35px #0000001a;
    /* padding: 0 0.95rem; */
    z-index: ${({ dynamicZIndex }) => (dynamicZIndex ? dynamicZIndex : '2000')};
    justify-content: space-between;

    ${media.smalDevice`
        justify-content: left;   
    `}
`;
export const HeaderWrapper = styled.div`
    width: 100%;
    position: fixed;
    top: 0;

    z-index: ${(props) => (props.accountSearchOpen || props.zindex  ? '0' : '2000')};
    max-height: 15rem;
    min-height: 3.75rem;
    ${media.mobileDevice`
        z-index:2000;  
    `}
    @media only screen and (min-width: 577px) and (max-width: 1024px) and (orientation: portrait) {
        z-index: 5000;
    }
    
`;
export const HamBurgerButton = styled.button`
    &.menu {
        appearance: none;
        font-size: 0;
        /* width:50px; */
        /* height:45px; */
        border: 0;
        background: transparent;
        border: 0;
        cursor: pointer;

        &span {
            display: block;
            width: 80%;
            height: 3px;
            /* background: #000; */
            margin-bottom: 5px;
            margin-left: auto;
            margin-right: auto;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    &.menu {
        position: relative;
        &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            /* background: #eebacd; */
            z-index: -1;
            opacity: 0;
            transition: 0.2s ease-out;
        }

        &:hover {
            &:after {
                opacity: 1;
            }
        }
    }
    width: 2rem;
    height: 1.5rem;
    background: transparent;
    border: none;
    flex-direction: column;
    justify-content: space-around;
    cursor: pointer;
    display: ${(props) =>
        isMobile && props.userDetailsAvailable ? 'flex' : 'none'};
    padding: 0;
    margin-left: 19px;
    & span {
        display: block;
        width: 18px;
        height: 2px;
        border-radius: 2px;
        background: #ffffff;
    }
    ${media.mediumDevice`       
       margin: 12px 10px 12px 10px;
    `}
    ${media.portraitDevice`
        display: ${(props) => (props.userDetailsAvailable ? 'flex' : 'none')};
        width: 18px;
        height: 14px;
        margin: 14px 12px;
`}
    
    ${media.mobileDevice`
       margin: 14px 12px;
    `}
`;

export const TitleTag = styled.h2`
    color: white;
    font-family: AvenirNextWorld Demi;
    margin: ${(props) =>
        isMobile
            ? '0.625rem 0'
            : props.userDetailsAvailable && '0.625rem 19px'};
    & span {
        color: #f4af3d;
        font-family: AvenirNextWorld Thin;
    }

    & a {
        text-decoration: none;
        color: white;
        cursor: ${({ cursor }) => cursor};
    }
    ${media.smalDevice`
    margin :${(props) =>
        props.userDetailsAvailable ? '0.625rem 0' : '0.625rem 24px'};
    `}

    ${media.mobileDevice`
        font-size: 18px;
        margin: 0.625rem 0;
    `}
`;

export const CondensedViewToggleButton = styled.div`
    display: flex;
    align-items: center;
    margin-top: -12px;
    ${media.mobileDevice`
        margin-top: 0px;
    `}
`;

export const SwitchLable = styled.span`
    color: white;
    font-size: 14px;
    align-items: center;
    width: max-content;
    margin-right: 30px;
    ${media.mobileDevice`

       margin-right: 12px;
        `}
`;

export const UserProfileContainer = styled.div`
    margin: 2px 0px;
    display: ${(props) => (isMobile || !props.userDetailsAvailable) && 'none'  || (!isMobile && props.userDetailsAvailable) && 'flex'};
    ${media.mobileDevice`
            display: none;
    `}
`;

export const LoaderContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 10px 15px;
    align-items: center;
    height: 3.75rem;
`;

const fadeOut = keyframes`
    from {
        transform: opacity(1);
    }

    to{
        transform: opacity(0);
    }
`;

export const DismissContainer = styled.div`
    animation: ${({ animate }) =>
        animate
            ? css`
                  ${fadeOut} 2s ease-out
              `
            : 'unset'};
    height: 3.75rem;
`;

export const StyledMoreDistrictSpan = styled.span`
    font-family: AvenirNextWorld Demi;
`;
